import { Alert, Button, Snackbar } from "@mui/material";
import { useState } from "react";

const NotificationToaste = ({
  message,
  messageType,
  open,
  handleCloseToaste,
}) => {
  //   const handleClickToaste = () => {
  //     setOpen(true);
  //   };

  //   const handleCloseToaste = (event, reason) => {
  //     if (reason === "clickaway") {
  //       return;
  //     }

  //     setOpen(false);
  //   };
  return (
    <div>
      <Snackbar open={open} autoHideDuration={4000} onClose={handleCloseToaste}>
        <Alert
          onClose={handleCloseToaste}
          severity={messageType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default NotificationToaste;
